









































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import Toggler from '@/components/Toggler.vue'
import NavigationFooter from '@/components/NavigationFooter.vue'
import TrackingMixin from '@/mixins/TrackingMixin.vue'
import IToggleOption from '@/store/interface/IToggleOption'
import refundOfferOptions from '@/store/data/refundOfferOptions'
import refundAcceptedOptions from '@/store/data/refundAcceptedOptions'
import refundReceivedOptions from '@/store/data/refundReceivedOptions'

/**
 * RefundDetails Page
 *
 * Defines whether the case is eligable or not, and routes customer to the
 * appropriate page, depending on his case
 */
@Component({
	name: 'RefundDetailsPage',
	components: {
		PageHeader,
		Toggler,
		NavigationFooter
	},
	mixins: [TrackingMixin]
})
export default class RefundDetailsPage extends Vue {
	private refundOfferList: IToggleOption[] = refundOfferOptions
	private refundAcceptedList: IToggleOption[] = refundAcceptedOptions
	private refundReceivedList: IToggleOption[] = refundReceivedOptions
	private isGermanDomain: boolean = this.$i18n.locale === 'de_DE'
	private isPageValid: boolean = this.isGermanDomain // For german domains validation is optional
	private refundOffered: boolean | null = null
	private refundAccepted: boolean | null = null
	private refundReceived: string | null = null
	private nextPage: string = 'step2'

	private onRefundToggleChange (refundOffered: boolean): void {
		this.refundOffered = refundOffered
		this.isPageValid = !refundOffered || this.isGermanDomain
		if (!refundOffered) {
			this.refundAccepted = null
			this.refundReceived = null
		}
	}

	private onRefundAcceptedToggleChange (refundAccepted: boolean): void {
		this.refundAccepted = refundAccepted
		this.isPageValid = !refundAccepted
		if (!refundAccepted) {
			this.refundReceived = null
		}
	}

	private onRefundReceivedToggleChange (nextPage: string): void {
		this.refundReceived = nextPage
		this.isPageValid = true
		this.nextPage = nextPage
	}

	private onPageSubmit (): void {
		this.$router.push(this.nextPage)
	}
}
